import firebase from 'firebase';

var config = {
    apiKey: "AIzaSyCB14TaGh6mvroKcIx1kRkHVuseryc3NK0",
    authDomain: "facil-backend-9c7db.firebaseapp.com",
    databaseURL: "https://facil-backend-9c7db.firebaseio.com",
    projectId: "facil-backend-9c7db",
    storageBucket: "facil-backend-9c7db.appspot.com",
    messagingSenderId: "901177215103"
};
firebase.initializeApp(config);
export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();
export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js